import { each, on } from "../common/polyfill.js";

on("click", "[data-toggle-target]", event => {
  let targetID = event.currentTarget.getAttribute("data-toggle-target");
  each(`[data-toggle-id="${targetID}"]`, el =>
    el.classList.toggle("is-hidden")
  );
});
